
import _requestHelper from '@/apiManager/_requestHelper';
import InitLoader from '@/components/UI/Loader/InitLoader.vue';
import routerManager from '@/routerManagerNew/routerManager';
import StoreService from '@/services/storeService';
import Vue from 'vue'
import { mapActions, mapState } from 'vuex';
export default Vue.extend({
    components: { 
        "init-loader": InitLoader 
    },    
    
    computed: {
        ...mapState("partner", ["partnerSettings"]),
        ...mapState("store", ["listOfStores"]),
    },
    
    methods: {
        ...mapActions("schedule", ["getStoreHomePageFirstAvailableSlots"]),
    },

    async mounted() {
        // get list of stores
        await StoreService.getElligibleStores();

        if(typeof this.listOfStores === "undefined" ||  this.listOfStores == null || this.listOfStores.length == 0)
            routerManager.goToStoresPage();

        else {

            var storeToUse = this.listOfStores[0];

            // get store details
            await StoreService.getStoreDetails(storeToUse.id);

            // get store first available slots
            await this.getStoreHomePageFirstAvailableSlots();

            if(this.$route.name === "rootPage") {

                if(this.partnerSettings.skipLandingPage == true) {
                    this.$router.push({
                        name: "storeHomePage",
                        params: {
                            storeId: storeToUse?.id,
                            storeDisplayName: storeToUse.displayName
                        },
                    })
                }
                else {
                    this.$router.push({
                        name: "landingPage"
                    })
                }
            }
        
        
            // if the deep link is a product
            // redirect to the item details
            else if(this.$route.name === "ProductDeepLink") {
                this.$router.push({
                    name: "productDetailsPage",
                    params: {

                        productId: this.$route.params["productId"], 
                        productName: this.$route.params["productName"],
                        storeId: storeToUse?.id.toString(),
                        storeDisplayName: storeToUse.displayName,
                        showWelcomeToast: "true"
                    },

                })
            }
            
            else if(this.$route.name === "StoreHomePageDeepLink") {
                this.$router.push({
                    name: "storeHomePage",
                    params: {
                        storeId: storeToUse?.id,
                        storeDisplayName: storeToUse.displayName
                    },
                })
            }
        }
    }
})
